import { clientOnlyLazy } from 'components/ClientOnlySuspense/clientOnlyLazy';
import { LoadableLoadingSection } from 'components/LoadableLoadingSection';

export const SelectOrgDashboardLoadable = clientOnlyLazy({
  loader: () =>
    import(
      /* webpackChunkName: "userDashboard/SelectOrgDashboardLoadable" */
      './SelectOrgDashboard'
    ),
  loading: LoadableLoadingSection,
});
